import { motion } from "framer-motion";
import { useContext } from "react";
import MDSpinner from "react-md-spinner";
import { AppContext } from "../../../Util/contexts/AppContext";

const ExamListLoader = () => {
  const { userData, primaryColor } = useContext(AppContext);

  return (
    <motion.div
      className="caseListLoadingContainer"
      initial={
        userData.AnimationsDisabled
          ? false
          : { opacity: 0, transform: `scale(0.95)` }
      }
      animate={
        userData.AnimationsDisabled
          ? false
          : { opacity: 1, transform: `scale(1)` }
      }
      exit={
        userData.AnimationsDisabled
          ? false
          : { opacity: 0, transform: `scale(0.95)` }
      }
    >
      <div className="caseListLoadingWrapper">
        <MDSpinner size={50} singleColor={primaryColor} />
        <p className="caseListLoadingText">Loading Exam List</p>
      </div>
    </motion.div>
  );
};

export default ExamListLoader;
